import LottieFile from "./LottieFile";

export default LottieFile;
